import styles from "./styles.scss";
import { FC } from "react";
import clsx from "clsx";
import { Button, ButtonSize, ButtonVariant } from "@/components/button";
import { EMPTY_DATA_STATES } from "@/components/empty-data-screen/configs";
import {
  EmptyDataScreenProps,
  EmptyDataScreenTypes,
} from "@/components/empty-data-screen/types";

export const EmptyDataScreen: FC<EmptyDataScreenProps> = ({
  className,
  buttonClassName,
  iconClassName,
  titleClassName,
  subtitleClassName,
  type,
  isHorizontal,
  icon,
  title,
  subtitle,
  buttonText,
  isIconHidden,
  isTitleHidden,
  isSubtitleHidden,
  onButtonClick,
}) => {
  const emptyDataType = type || EmptyDataScreenTypes.NoResults;
  const { ICON, TITLE, SUBTITLE } = EMPTY_DATA_STATES[emptyDataType];
  const emptyDataIcon = icon || ICON;
  const emptyDataTitle = title || TITLE;
  const emptyDataSubtitle = subtitle || SUBTITLE;

  return (
    <div
      className={clsx(
        styles.wrapper,
        isHorizontal && styles.horizontal,
        className,
      )}
    >
      {!isIconHidden && (
        <div className={clsx(styles.icon, iconClassName)}>{emptyDataIcon}</div>
      )}

      <div
        className={clsx(
          styles.contentWrapper,
          isHorizontal && styles.horizontal,
          isIconHidden && styles.noMargin,
        )}
      >
        {!isTitleHidden && (
          <div
            className={clsx(
              styles.title,
              isHorizontal && styles.horizontal,
              isIconHidden && styles.noMargin,
              titleClassName,
            )}
          >
            {emptyDataTitle}
          </div>
        )}

        {!isSubtitleHidden && (
          <div
            className={clsx(
              styles.subtitle,
              isHorizontal && styles.horizontal,
              isIconHidden && isTitleHidden && styles.noMargin,
              subtitleClassName,
            )}
          >
            {emptyDataSubtitle}
          </div>
        )}

        {buttonText && (
          <Button
            className={clsx(
              styles.emptyDataScreenButton,
              styles.button,
              isHorizontal && styles.horizontal,
              isIconHidden &&
                isTitleHidden &&
                isSubtitleHidden &&
                styles.noMargin,
              buttonClassName,
            )}
            onClick={onButtonClick}
            variant={ButtonVariant.Primary}
            size={ButtonSize.Small}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};
